/**
 * Get HubSpot tracking cookie (hubspotutk)
 * @returns {string|null} HubSpot cookie value or null if not found
 */
export function getHubSpotCookie() {
	const name = 'hubspotutk='
	const decodedCookie = decodeURIComponent(document.cookie)
	const cookies = decodedCookie.split(';')

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim()
		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length)
		}
	}

	return null
}
